<mat-tab-group animationDuration="0ms">
  <mat-tab>
    <ng-template mat-tab-label>
      {{ 'waters.season-periods.tab.periods' | translate }}
      @if (periodsCount()) {
        <span
          class="ml-2 inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full bg-teal-700 text-white text-xs font-medium">
          {{ periodsCount() }}
        </span>
      }
    </ng-template>
    <app-season-periods-default-tab [waterId]="waterId()" (count)="periodsCount.set($event)" />
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      {{ 'waters.season-periods.tab.exceptions' | translate }}
      @if (exceptionsCount()) {
        <span
          class="ml-2 inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full bg-teal-700 text-white text-xs font-medium">
          {{ exceptionsCount() }}
        </span>
      }
    </ng-template>
    <app-season-periods-exceptions-tab [waterId]="waterId()" (count)="exceptionsCount.set($event)" />
  </mat-tab>
</mat-tab-group>
